// extracted by mini-css-extract-plugin
export default {"feedback":"Feedback_feedback__nSfKD","full-width":"Feedback_full-width__QLY8K","invalid":"Feedback_invalid__7JDCW","warn":"Feedback_warn__e+JJt","valid":"Feedback_valid__bqOTH"};